import { createTheme, ThemeOptions } from "@mui/material";

declare module "@mui/material/styles" {
  interface Palette {
    diable: Palette["primary"];
    transparent: Palette["primary"];
    textDisable: Palette["primary"];
    secondaryButton: Palette["primary"];
  }
  interface PaletteOptions {
    diable?: PaletteOptions["primary"];
    transparent?: PaletteOptions["primary"];
    textDisable?: PaletteOptions["primary"];
    secondaryButton?: PaletteOptions["primary"];
  }
}

const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: "#315659",
    },
    secondary: {
      main: "#BCAB79",
      contrastText: "white",
    },
    diable: {
      main: "#e7e7e7",
      contrastText: "white",
    },
    transparent: {
      main: "rgba(255, 255, 255, 0)",
    },
    textDisable: {
      main: "#D6D6D6",
    },
    secondaryButton: {
      main: "#253031",
      contrastText: "white",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
          "&:active": {
            boxShadow: "none",
          },
          "&:focus": {
            boxShadow: "none",
          },
        },
      },
    },
  },
};

const theme = createTheme(themeOptions);

export default theme;
